import { Component, Input, OnInit, Output } from '@angular/core';

import { PopoverController } from '@ionic/angular';

import { Subscription } from 'rxjs';

import { EstatusService } from 'src/app/services/estatus.service';

@Component({
  selector: 'app-tipificacion-popover',
  templateUrl: './tipificacion-popover.component.html',
  styleUrls: ['./tipificacion-popover.component.scss'],
})
export class TipificacionPopoverComponent implements OnInit {

  @Input() idAdmin;
  @Input() id;
  @Input() rol;
  @Input() token;
  @Input() urlBack;

  @Output() option;

  typifications: Subscription;
  typificationNames;

  constructor(
    private popoverController: PopoverController,
    private estatusServ: EstatusService,
  ) {
    this.typificationNames = [];
  }

  ngOnInit() {
    this.getTypification();
  }

  getTypification() {
    this.typifications = this.estatusServ.getAllEstatus(this.idAdmin, this.id, this.rol,
      this.token, this.urlBack).subscribe((res: any) => {
        const { status, listaEstatus } = res;
        if (status === 'success') {
          this.typificationNames = listaEstatus;
        }
      });
  }

  getOption(elemento) {
    console.log('Opción elegida(lado del hijo):', elemento.estatus);
    this.option = elemento.estatus;
    this.popoverController.dismiss(this.option);
  }

  closePopover() {
    this.popoverController.dismiss();
  }

}
